import { ViewModel, View, ObservableArray } from "binder"
import { NotificationsPopupView } from "./notificationsPopup-view"
import { ServerConnection } from "src/server/serverConnection";
import moment from "moment";
import { CreateWindowMessage } from "../../userMainWindow-viewModel";

export class NotificationsPopupViewModel extends ViewModel {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.hasUnseen = false;
        this.isShowingPopup = false;
        this.notifications = ObservableArray.create<notifications>();
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new NotificationsPopupView();
    }
    public getTypeId(): string {
        return "VM-BC766F37-E8D3-4E33-BA39-388BCB217516"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set notifications(v: ObservableArray<notifications>) { this._notifications = v; } public get notifications(): ObservableArray<notifications> { return this._notifications; } private _notifications: ObservableArray<notifications>;
    public set hasUnseen(v: boolean) { this._hasUnseen = v; } public get hasUnseen(): boolean { return this._hasUnseen; } private _hasUnseen: boolean;
    public set hasUnreceived(v: boolean) { this._hasUnreceived = v; } public get hasUnreceived(): boolean { return this._hasUnreceived; } private _hasUnreceived: boolean;
    public set isShowingPopup(v: boolean) {
        this._isShowingPopup = v;
        if (v == true) {
            if (this.hasUnreceived == true) {
                this.setNotificationsReceived();
                this.hasUnreceived = false;
            }
        }
    } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;

    async setNotificationsReceived() {
        try {
            let result = await ServerConnection.callServer('/Complex/UserNotifications/SetNonStartupNotificationsReceived', {});
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }
    async refresh() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/UserNotifications/ListReceivedNotifications', {
                FurtherQueryInfo: { PaginationInfo: { PageNo: 1, PageSize: 20 }, OrderInfo: [], Filters: { FilterString: "" } }
            });
            this.notifications.update(...result.Notifications.map((x: any) => {
                let r = new notifications(this);
                r.id = x.Id;
                r.title = x.Title;
                r.body = x.Body;
                r.alertType = x.AlertType;
                r.creationTime = moment.utc(x.CreationTime);
                r.senderUsername = x.SenderUsername;
                return r;
            }));
            this.hasUnseen = result.Notifications.some(x => x.IsShown == false);
            this.hasUnreceived = result.Notifications.some(x => x.IsReceived == false);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    showAll() {
        this.handleMessage(new CreateWindowMessage('cd3eab4a-4981-4d37-b914-5f01caff7ad3'));
    }
}

export class notifications extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
    public set body(v: string) { this._body = v; } public get body(): string { return this._body; } private _body: string;
    public set alertType(v: number) { this._alertType = v; } public get alertType(): number { return this._alertType; } private _alertType: number;
    public set senderUsername(v: string) { this._senderUsername = v; } public get senderUsername(): string { return this._senderUsername; } private _senderUsername: string;

}